import React from "react";
import {defaultOptions} from "../../../config";
export default (props) => {
	return <img src={`${defaultOptions.baseUrl}/api${props.url}`} alt="" {...props}/>;
};